module.exports = new __parcel__URL__("strawberry.4111dfb6.svg").toString();